import { Option } from '@contact/upgrade';

export interface IChatGuest {
  id: string;
  firstName: string;
  lastName: string;
  groups: string[];
  team?: string;
  role?: string;
  isPresent: boolean;
  isOngoing?: boolean;
}

export class ChatGuest {
  static fromDto(dto): IChatGuest {
    return {
      id: dto.userId,
      firstName: dto.firstName,
      lastName: dto.lastName,
      groups: Option.of(dto.groups).getOrElse([]),
      team: dto.team,
      role: dto.role,
      isPresent: dto.isPresent,
    };
  }

  static toDto(guest: IChatGuest): any {
    return {
      userId: guest.id,
      firstName: guest.firstName,
      lastName: guest.lastName,
      groups: Option.of(guest.groups).getOrElse([]),
      team: guest.team,
      role: guest.role,
      isPresent: guest.isPresent,
    };
  }
}
